module.exports = __webpack_public_path__ + "img/001-witch.53a370c3.png";